"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useDNDOnDragEnd = void 0;
var ejson_1 = __importDefault(require("ejson"));
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var UpdateTaskStatusBP = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/update-task-status"));
var react_1 = __importDefault(require("react"));
var status_1 = require("../consts/status");
function useDNDOnDragEnd(_a) {
    var _this = this;
    var order = _a.order, tasks = _a.tasks, onChangeOrder = _a.onChangeOrder;
    var client = (0, omni_continuity_1.useClient)();
    var updateTaskStatusMutation = client.useMutation(UpdateTaskStatusBP);
    var cb = react_1["default"].useCallback(function (evt) { return __awaiter(_this, void 0, void 0, function () {
        var task, source, target, newOrder, updatedTask, status_2, key;
        var _a, _b;
        return __generator(this, function (_c) {
            task = tasks.find(function (task) { return task.uuid === evt.draggableId; });
            if (task == null) {
                throw new Error("onDragEnd called for null task ".concat(evt.draggableId));
            }
            source = task.status.id;
            target = ((_a = evt.destination) === null || _a === void 0 ? void 0 : _a.droppableId) === "all"
                ? source
                : (_b = evt.destination) === null || _b === void 0 ? void 0 : _b.droppableId;
            if (target == null) {
                throw new Error("target is null");
            }
            if (evt.destination == null)
                return [2 /*return*/];
            newOrder = ejson_1["default"].clone(order);
            if (evt.destination == null)
                return [2 /*return*/];
            if (newOrder[source] == null) {
                throw new Error("newOrder[".concat(source, "] is null"));
            }
            newOrder[source].splice(newOrder[source].indexOf(evt.draggableId), 1);
            if (newOrder[target] == null) {
                newOrder[target] = [];
            }
            newOrder[target].splice(evt.destination.index, 0, evt.draggableId);
            updatedTask = null;
            // TODO we should NOT be calling mutations from state set but this is speed coding
            if (evt.source.droppableId !== target) {
                status_2 = status_1.AllStatuses.find(function (s) { return s.id === target; });
                void updateTaskStatusMutation.call({
                    taskUUID: evt.draggableId,
                    status: status_2,
                    order: null
                });
                if (task != null) {
                    updatedTask = __assign(__assign({}, task), { status: status_2 });
                }
            }
            for (key in newOrder) {
                newOrder[key] = newOrder[key].filter(function (o) { return typeof o === "string"; });
            }
            onChangeOrder(newOrder, updatedTask);
            return [2 /*return*/];
        });
    }); }, [order, tasks, onChangeOrder]);
    return cb;
}
exports.useDNDOnDragEnd = useDNDOnDragEnd;
